import "./SegmentedTabsComp.css";
import { defineComponent as m, openBlock as s, createElementBlock as a, createElementVNode as p, toDisplayString as l, Fragment as b, renderList as u, createBlock as k, normalizeClass as f, withCtx as C, createTextVNode as g } from "vue";
import { ButtonComp as T } from "./ButtonComp.js";
import { _ as h } from "./_plugin-vue_export-helper.dad06003.js";
const x = { class: "segmentedTabs" }, B = { class: "segmentedTabs__label" }, v = /* @__PURE__ */ m({
  __name: "SegmentedTabsComp",
  props: {
    label: {},
    items: {}
  },
  emits: ["tabClicked"],
  setup(c, { emit: r }) {
    const o = c, _ = r, d = (t) => {
      t.selected || (o.items.forEach((n) => n.selected = !1), t.selected = !0), _("tabClicked", t);
    };
    return (t, n) => (s(), a("div", x, [
      p("p", B, l(t.label), 1),
      (s(!0), a(b, null, u(o.items, (e, i) => (s(), k(T, {
        class: f({
          segmentedTabs__tabLinkButton: !0,
          "segmentedTabs__tabLinkButton--selected": e.selected
        }),
        blank: !e.to,
        routerLink: !!e.to,
        to: e.to,
        onClick: (L) => d(e),
        key: i,
        "t-sel": e.tSel
      }, {
        default: C(() => [
          g(l(e.text), 1)
        ]),
        _: 2
      }, 1032, ["class", "blank", "routerLink", "to", "onClick", "t-sel"]))), 128))
    ]));
  }
});
const V = /* @__PURE__ */ h(v, [["__scopeId", "data-v-8f5b4918"]]);
export {
  V as SegmentedTabsComp
};
//# sourceMappingURL=SegmentedTabsComp.js.map
